import http, { url } from '../../http'

const API_URL = "identification_evaluation_products_services"

class identificacionEvaluacionPSAPI {

  async save(identification_evaluation_products_services) {
    const response = await http(`${API_URL}/save`, 'POST', identification_evaluation_products_services)
    return response
  }
 
  async getAll(id) {
    const response = await http(`${API_URL}/index/${id}`, 'POST')
    return response
  } 

  async getAllIdentificacion(id, page, search) {
    const response = await http(`${API_URL}/index/${id}?page=${page}&search=${search}`, 'POST')
    return response
  } 

  async getFiles(id) {
    const response = await http(`identification_evaluation_files/${id}`, 'POST')
    return response
  } 

  async show(id) {
    const response = await http(`identification_evaluation_products_services/${id}`)
    return response
  } 

  async update(id, revision) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', revision)
    return response
  }
  async deleteRevision(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

  
}

export default new identificacionEvaluacionPSAPI()